import { Column } from 'primereact/column'
import { connect } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { Btn, CustomCheckbox, CustomDataTableHeader, CustomModal } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useModalAssocCompanies, { LOAD_MESSAGE } from './ModalAssocCompaniesHook'

function ModalAssocCompanies({ dispatch, show, data, onModalClose, onModalSave }) {
  const { state, localDispatch } = useModalAssocCompanies()

  useEffect(() => {
    if (show) localDispatch.onInit(data)
  }, [data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_COMPANIES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCompaniesToAssoc()
        break

      case LOAD_MESSAGE.SAVE_ASSOC:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.saveAssocCompanyGroup(state.company_group, state.companies)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.updatedCompanyGroup)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header={`${state.company_group.id ? 'Editando' : 'Novo'} Grupo de Empresas`}
      isVisible={show}
      width={500}
      onClose={onModalClose}
    >
      <form className="p-grid" style={{ width: 500 }}>
        <div className="p-col-12">
          <DataTable
            value={state.companies}
            paginator={true}
            rows={5}
            header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
            globalFilter={state.globalFilter}
          >
            <Column
              header={'#'}
              body={company => (
                <CustomCheckbox
                  checked={company.selected}
                  onChange={() => localDispatch.onCheckboxChange(company)}
                />
              )}
              style={tableCellCentered(80)}
            />
            <Column field={'company_name'} header={'Companhia'} />
          </DataTable>
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClick(state.companies)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalAssocCompanies)
